import { useQuery } from 'react-query'
import { fetchWorkspaces } from 'api/clients/userClient'

export default () => useQuery('workspaces', fetchWorkspaces)
